export default "__VITE_ASSET__B4PNKG2E__"